import SubHeading from '@/components/SubHeading';
import Container from '@/components/Container';

export default function Resources() {
  return (
    <div className="bg-green-100 bg-gradient-to-br from-green-100 to-green-50">
      <Container>
        <div className="grid grid-cols-1 lg:grid-cols-12">
          <div className="flex flex-col py-10 lg:col-span-6 lg:py-20">
            <SubHeading heading="Recursos" />
            <h1 className="text-4xl font-extrabold lg:text-5xl">
              Te recomendamos algunos recursos para tu aprendizaje
            </h1>
          </div>
        </div>
      </Container>
    </div>
  );
}
